var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgRightArrow(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 51.438,
    height: 25.357
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    "data-name": "\\u30D1\\u30B9 672",
    d: "M46.489 11.678H0v2h46.489A59.6 59.6 0 0035.76 24.19l1.668 1.168a55.907 55.907 0 0114.01-12.679A55.907 55.907 0 0137.424 0L35.76 1.168a59.6 59.6 0 0010.729 10.51z"
  })));
}
export default SvgRightArrow;